import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReduxComponent } from './simple-icons-redux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReduxComponent ],
    exports:      [ SimpleIconsReduxComponent ],
    bootstrap:    []
})
export class SimpleIconsReduxModule {}
